import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateCreationFailedAction = {
	type: 'DOCUMENT_TEMPLATE_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateCreationFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_CREATION_FAILED',
	payload,
});
